export async function downloadFile(url: string): Promise<string> {
  if (window.unitTest) {
    throw new Error("downloadFile() must be mocked in unit tests");
  }
  const maxAttempts = 3;
  let attempt = 0;
  for (;;) {
    ++attempt;
    try {
      const response = await fetch(url);
      if (!response.ok) {
        throw new Error(`Failed to fetch ${url}: ${response.status} ${response.statusText}`);
      }
      const fileContent = await response.text();
      return fileContent;
    } catch (error) {
      if (attempt < maxAttempts) {
        const delay = 500 * Math.pow(2, attempt);
        console.info(
          `Attempt ${attempt}/${maxAttempts} to download ${url} failed -- trying again in ${delay} ms`,
          error,
        );
        await new Promise((resolve) => setTimeout(resolve, delay));
      } else {
        throw error;
      }
    }
  }
}
